import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  projectCard: {
    backgroundColor: "rgba(255, 255, 255, 0.05)",
    borderRadius: "2rem",
    padding: theme.spacing(4),
    border: "1px solid rgba(223, 224, 255, 0.1)",
    boxShadow: "0 20px 80px rgba(0,0,0,0.3)",
    textAlign: "left",
    transition: "all 0.3s ease",
    display: "flex",
    flexDirection: "column",
    minHeight: 400,
    "&:hover": {
      borderColor: "rgba(223, 224, 255, 0.2)",
      boxShadow: "0 24px 90px rgba(0,0,0,0.4)",
    },
  },

  imageContainer: {
    position: "relative",
  },

  projectImage: {
    width: 200,
    height: 200,
    borderRadius: "1rem",
    objectFit: "cover",
    transition: "transform 0.4s ease",
    "$projectCard:hover &": {
      transform: "scale(1.03)",
    },
    [theme.breakpoints.down("xs")]: {
      width: "100%",
      height: "auto",
    },
  },

  verifiedBadge: {
    position: "absolute",
    top: 12,
    left: 12,
    backgroundColor: "#06e89f",
    color: "#006341",
    padding: "6px 16px",
    borderRadius: 100,
    fontSize: 10,
    fontWeight: 800,
    letterSpacing: "1px",
    boxShadow: "0 4px 12px rgba(6, 232, 159, 0.4)",
  },

  premiumLabel: {
    color: "#06e89f",
    fontSize: 11,
    fontWeight: 800,
    letterSpacing: "1.2px",
    textTransform: "uppercase",
    marginBottom: theme.spacing(1),
  },

  projectTitle: {
    color: theme.palette.text.invesment,
    fontSize: "2rem",
    fontWeight: 800,
    letterSpacing: "-0.01em",
    marginBottom: theme.spacing(1.5),
    lineHeight: 1.2,
    transition: "color 0.3s ease",
    "$projectCard:hover &": {
      color: "#06e89f",
    },
  },

  locationRow: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(3),
  },

  locationIcon: {
    color: theme.palette.text.investementlocationIcon,

    fontSize: 18,
    marginRight: 6,
  },

  locationText: {
    color: theme.palette.text.investementlocationIcon,

    fontSize: 14,
  },

  typeButtonsContainer: {
    marginTop: theme.spacing(2),
  },

  formControl: {
    width: "100%",
  },

  radioGroup: {
    width: "100%",
    display: "flex",
    gap: theme.spacing(2),
  },
  hiddenRadio: {
    display: "none",
  },

  formControlLabel: {
    margin: 0,
    flex: 1,
    display: "flex",
    "& .MuiFormControlLabel-label": {
      flex: 1,
      width: "100%",
    },
  },

  typeButtonActive: {
    width: "100%",
    borderRadius: 12,
    border: "1px solid #06e89f",
    backgroundColor: "rgba(6, 232, 159, 0.15)",
    color: "#06e89f",
    padding: "10px 16px",
    textTransform: "none",
    fontSize: 13,
    fontWeight: 700,
    letterSpacing: "0.3px",
    transition: "all 0.3s ease",
    "&:hover": {
      backgroundColor: "rgba(6, 232, 159, 0.25)",
      transform: "translateY(-2px)",
    },
  },

  typeButtonInactive: {
    width: "100%",
    borderRadius: 12,
    border: "1px solid rgba(223, 224, 255, 0.2)",
    backgroundColor: "transparent",

    color: theme.palette.text.investementlocationIcon,
    padding: "10px 16px",
    textTransform: "none",
    fontSize: 13,
    fontWeight: 600,
    transition: "all 0.3s ease",
    "&:hover": {
      borderColor: "rgba(223, 224, 255, 0.4)",
      backgroundColor: "rgba(223, 224, 255, 0.05)",
    },
    "&:disabled": {
      opacity: 0.3,
      cursor: "not-allowed",
    },
  },

  quantitySelectorSection: {
    marginTop: theme.spacing(6),
    paddingTop: theme.spacing(4),
    borderTop: `0.1px solid ${theme.palette.text.quantitySelectorSection}`,

    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: theme.spacing(2),
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      alignItems: "flex-start",
    },
  },

  quantityLabel: {
    color: theme.palette.text.invesment,
    fontSize: 15,
    fontWeight: 600,
  },

  counterContainer: {},
}));

export { useStyles };
